import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

import { v4 } from "uuid";
import _ from "lodash";

const initialState = {
    layerleftsidebarshow: false,
    layercontent_skep: false,
    temp_layer_show: false,
    draw_layer_datalayer: null,
    editlayer_custom: false,
    editting: null,
    editlayer_resetdata: null,
    layers_custom: {
        loading: true,
        error: {},
        data: []
    },
    layersmetadata_custom: {
        loading: true,
        error: {},
        data: []
    },
    layersdata_custom: [],
    layerDropdown_custom: [],
    layersAkief_custom: [],
    featureError: null,
    popovershow: false,
    popovercoordinates: { lat: -27.988421, lng: 25.025322 },
    activeFeature: null,
    layer: {
        loading: false,
        error: false,
        errordata: {},
        success: false
    },
    skep_layer_custom: {
        loading: false,
        error: false,
        errordata: {},
        success: false
    },
    layernaam: {
        loading: false,
        error: false,
        errordata: {},
        success: false
    },
    telling: 3,
    naamedit: null,
    logs: [],
    icons: {
        loading: true,
        error: false,
        errordata: {},
        data: []
    },
    drawingmode: "marker",
    drawingManager: null,
    activeTemplate: null,
    templaaticons: [{
        id: 1,
        iconPath: "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
        strokeColor: "#000",
        strokeWeight: 1,
        strokeOpacity: 1,
        fillColor: "#000",
        fillOpacity: 0.3,
    }],
    templaaticon: null
};

const toggleLayerLeftSidebar = (state, action) => {
    return updateObject(state, {
        layerleftsidebarshow: action.value != null ? action.value : !state.layerleftsidebarshow,
        layercontent_skep: action.skep
    });
};

const skepTempCustomLayer = (state, action) => {
    let log = [{
        aksie: "CREATE",
        objek: "LAYER",
        layer: action.layer
    },
    {
        aksie: "CREATE",
        objek: "LAYERVERSION",
        layer: action.layer,
        version: action.version,
    }];

    return updateObject(state, {
        layerleftsidebarshow: true,
        layercontent_skep: true,
        temp_layer_show: true,
        draw_layer_datalayer: action.datalayer,
        logs: [...state.logs, ...log],
        editting: {
            layer: action.layer,
            weergawe: action.version
        },
        drawingmode: "marker",
        drawingManager: action.drawingManager
    });
};

const skepCustomLayerLoading = (state, action) => {
    return updateObject(state, {
        skep_layer_custom: {
            ...state.skep_layer_custom,
            loading: true,
        }
    });
};

const skepCustomLayerSuccess = (state, action) => {
    return updateObject(state, {
        skep_layer_custom: {
            ...state.skep_layer_custom,
            loading: false,
            success: true,
        }
    });
};

const skepCustomLayerFailed = (state, action) => {
    return updateObject(state, {
        skep_layer_custom: {
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const skepCustomLayerClearnotification = (state, action) => {
    return updateObject(state, {
        skep_layer_custom: {
            loading: false,
            success: false,
            error: false,
            errordata: null,
        }
    });
};

const skepCustomLayerTelling = (state, action) => {
    return updateObject(state, {
        telling: action.telling
    });
};

const skepCustomLayerClose = (state, action) => {
    return updateObject(state, {
        layerleftsidebarshow: false,
        layercontent_skep: false,
        temp_layer_show: false,
        draw_layer_datalayer: null,
        skep_layer_custom: {
            loading: false,
            success: false,
            error: false,
            errordata: null,
        },
        telling: 3,
        logs: []
    });
};

const editTempCustomLayerError = (state, action) => {
    return updateObject(state, {
        featureError: action.value !== false ? "Die layer bevat te veel data, skep asb. 'n aparte layer om meer data te weerspiel." : null
    });
};

const toggleFeatureInfoBox = (state, action) => {
    if (state.editting) {
        let activeFeature = null;
        if (action.feature) {
            let styles = {};
            let data = [];
            let inligting = [];
            let beskrywing = "";

            let i = 1;
            action.feature.forEachProperty((value, name) => {
                let type = action.feature?.getGeometry()?.getType();
                if (type === "Point" || type === "Polygon") {
                    if ((['strokeColor', 'strokeWeight', 'strokeOpacity', 'fillColor', 'fillOpacity', 'iconPath']).indexOf(name) !== -1) {
                        styles[name] = value;
                    } else if (['beskrywing'].indexOf(name) !== -1) {
                        beskrywing = value;
                    } else {
                        data.push({ id: i, name: name, value: value });
                    }
                } else if (type === "LineString") {
                    if ((['strokeColor', 'strokeWeight', 'strokeOpacity']).indexOf(name) !== -1) {
                        styles[name] = value;
                    } else if (['beskrywing'].indexOf(name) !== -1) {
                        beskrywing = value;
                    } else {
                        data.push({ id: i, name: name, value: value });
                    }
                }
                i++;
            });

            let geometry = action.feature?.getGeometry();
            if (geometry) {
                if (geometry.getType() === 'LineString') {
                    let latlngs = [];
                    geometry.forEachLatLng(latLng => latlngs.push(latLng));
                    let distance = action.google.maps.geometry.spherical.computeLength(latlngs);
                    inligting = [
                        {
                            id: "m",
                            name: "Afstand (m)",
                            value: distance.toFixed(2)
                        },
                        {
                            id: "km",
                            name: "Afstand (km)",
                            value: (distance / 1000).toFixed(2)
                        },
                    ];
                } else if (geometry.getType() === 'Point') {
                    inligting = [
                        {
                            id: "lat",
                            name: "Latitude",
                            value: geometry.get().lat().toFixed(4)
                        },
                        {
                            id: "lng",
                            name: "Longitude",
                            value: geometry.get().lng().toFixed(4)
                        }
                    ];
                } else if (geometry.getType() === 'Polygon') {
                    let latlngs = [];
                    geometry.forEachLatLng(latLng => latlngs.push(latLng));
                    let area = action.google.maps.geometry.spherical.computeArea(latlngs);
                    let omtrek = action.google.maps.geometry.spherical.computeLength(latlngs);
                    inligting = [
                        {
                            id: "ha",
                            name: "Hektar",
                            value: (area / 10000).toFixed(2)
                        },
                        {
                            id: "m2",
                            name: "Vierkant meter",
                            value: area.toFixed(2)
                        },
                        {
                            id: "km2",
                            name: "Vierkant kilometer",
                            value: (area / 1000000).toFixed(2)
                        },
                        {
                            id: "m1",
                            name: "Omtrek (m)",
                            value: omtrek.toFixed(2)
                        },
                        {
                            id: "km1",
                            name: "Omtrek (km)",
                            value: (omtrek / 1000).toFixed(2)
                        },
                    ];
                }
            }

            activeFeature = {
                id: action.feature.getProperty("id"),
                tipe: geometry.getType(),
                style: styles,
                data: data,
                beskrywing: beskrywing,
                inligting: inligting,
                feature: action.feature
            };
        }

        return updateObject(state, {
            popovershow: action.open,
            popovercoordinates: action.coordinates,
            activeFeature: activeFeature
        });
    } else {
        const newlayersmetadata = _.cloneDeep(state.layersmetadata_custom.data);
        for (var layer of newlayersmetadata) {
            for (const weergawe of layer.weergawes) {
                if (weergawe.datalayer?.getFeatureById(action.feature.getId())) {
                    let inligting = [];
                    let geometry = action.feature?.getGeometry();
                    if (geometry) {
                        if (geometry.getType() === 'LineString') {
                            let latlngs = [];
                            geometry.forEachLatLng(latLng => latlngs.push(latLng));
                            let distance = action.google.maps.geometry.spherical.computeLength(latlngs);
                            inligting = [
                                {
                                    id: "m",
                                    name: "Afstand (m)",
                                    value: distance.toFixed(2)
                                },
                                {
                                    id: "km",
                                    name: "Afstand (km)",
                                    value: (distance / 1000).toFixed(2)
                                },
                            ];
                        } else if (geometry.getType() === 'Point') {
                            inligting = [
                                {
                                    id: "lat",
                                    name: "Latitude",
                                    value: geometry.get().lat().toFixed(4)
                                },
                                {
                                    id: "lng",
                                    name: "Longitude",
                                    value: geometry.get().lng().toFixed(4)
                                }
                            ];
                        } else if (geometry.getType() === 'Polygon') {
                            let latlngs = [];
                            geometry.forEachLatLng(latLng => latlngs.push(latLng));
                            let area = action.google.maps.geometry.spherical.computeArea(latlngs);
                            let omtrek = action.google.maps.geometry.spherical.computeLength(latlngs);
                            inligting = [
                                {
                                    id: "ha",
                                    name: "Hektar",
                                    value: (area / 10000).toFixed(2)
                                },
                                {
                                    id: "m2",
                                    name: "Vierkant meter",
                                    value: area.toFixed(2)
                                },
                                {
                                    id: "km2",
                                    name: "Vierkant kilometer",
                                    value: (area / 1000000).toFixed(2)
                                },
                                {
                                    id: "m1",
                                    name: "Omtrek (m)",
                                    value: omtrek.toFixed(2)
                                },
                                {
                                    id: "km1",
                                    name: "Omtrek (km)",
                                    value: (omtrek / 1000).toFixed(2)
                                },
                            ];
                        }
                    }
                    weergawe.infowindows = [weergawe.infowindows, {
                        id: action.feature.getId(),
                        coordinates: action.coordinates,
                        data: {
                            notas: action.feature.getProperty("beskrywing") || null,
                            inligting: inligting
                        }
                    }];
                    weergawe.infowindows = _.flattenDeep(weergawe.infowindows).filter(item => item);
                }
            }
        }

        return updateObject(state, {
            layersmetadata_custom: {
                ...state.layersmetadata_custom,
                data: newlayersmetadata,
            }
        });
    }
};

const closeInfoWindow_custom = (state, action) => {
    const newlayersmetadata = _.cloneDeep(state.layersmetadata_custom.data);
    for (var layer of newlayersmetadata) {
        if (action.layer) {
            if (layer.id === action.layer) {
                for (const weergawe of layer.weergawes) {
                    if (action.version && weergawe.id === action.version) {
                        delete weergawe.infowindows;
                        delete weergawe.infowindowstype;
                    }
                }
            }
        } else {
            for (const weergawe of layer.weergawes) {
                if (action.id) {
                    if (weergawe.datalayer?.getFeatureById(action.id)) {
                        let index = weergawe.infowindows.map(item => item.id).indexOf(action.id);
                        if (index !== -1) {
                            weergawe.infowindows.splice(index, 1);
                        }
                        weergawe.infowindows = _.flattenDeep(weergawe.infowindows).filter(item => item);
                    }
                }
            }
        }
    }

    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        }
    });
};

const verwyderFeature = (state, action) => {
    return updateObject(state, {
        popovershow: false,
        popovercoordinates: initialState.popovercoordinates,
        activeFeature: null,
    });
};

const editFeatureProperty = (state, action) => {
    let activeFeature = null;
    if (action.feature) {
        let styles = {};
        let beskrywing = "";

        action.feature.forEachProperty((value, name) => {
            let type = action.feature?.getGeometry()?.getType();
            if (type === "Point" || type === "Polygon") {
                if ((['strokeColor', 'strokeWeight', 'strokeOpacity', 'fillColor', 'fillOpacity', 'iconPath']).indexOf(name) !== -1) {
                    styles[name] = value;
                } else if (['beskrywing'].indexOf(name) !== -1) {
                    beskrywing = value;
                }
            } else if (type === "LineString") {
                if ((['strokeColor', 'strokeWeight', 'strokeOpacity']).indexOf(name) !== -1) {
                    styles[name] = value;
                } else if (['beskrywing'].indexOf(name) !== -1) {
                    beskrywing = value;
                }
            }
        });

        action.datalayer.overrideStyle(action.feature, styles);

        activeFeature = {
            ...state.activeFeature,
            id: action.feature.getProperty("id"),
            style: styles,
            beskrywing: beskrywing,
            feature: action.feature
        };
    }

    let log = {
        aksie: "EDIT",
        objek: "FEATURE",
        layer: state.editting?.layer,
        version: state.editting?.weergawe,
        feature: action.id
    };
    return updateObject(state, {
        logs: [...state.logs, log],
        activeFeature: activeFeature
    });
};

const stoorCustomLayerLoading = (state, action) => {
    return updateObject(state, {
        layer: {
            ...state.layer,
            loading: true,
        }
    });
};

const stoorCustomLayerSuccessMessage = (state, action) => {
    return updateObject(state, {
        layer: {
            loading: false,
            success: true,
            error: false,
            errordata: null,
        },
    });
};

const stoorCustomLayerSuccess = (state, action) => {
    const newlayersmetadata = [...state.layersmetadata_custom.data];
    for (var layer of newlayersmetadata) {
        for (var weergawe of layer.weergawes) {
            if (weergawe.id === state.editting.weergawe && weergawe.datalayer) {
                weergawe.datalayer.setStyle(feature => {
                    let icon = {};
                    if (feature?.getGeometry()?.getType() === "Point") {
                        icon = {
                            icon: {
                                path: feature.getProperty("iconPath") || "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
                                fillColor: feature.getProperty("fillColor"),
                                fillOpacity: feature.getProperty("fillOpacity"),
                                strokeColor: feature.getProperty("strokeColor"),
                                strokeWeight: feature.getProperty("strokeWeight"),
                                strokeOpacity: feature.getProperty("strokeOpacity"),
                                anchor: new window.google.maps.Point(12, 24),
                                scale: 1.5
                            }
                        };
                    }
                    return {
                        strokeColor: feature.getProperty("strokeColor"),
                        strokeWeight: feature.getProperty("strokeWeight"),
                        strokeOpacity: feature.getProperty("strokeOpacity"),
                        fillColor: feature.getProperty("fillColor"),
                        fillOpacity: feature.getProperty("fillOpacity"),
                        ...icon,
                        zIndex: 9998,
                        clickable: true,
                        editable: false,
                        draggable: false
                    };
                });
            }
        }
    }

    return updateObject(state, {
        temp_layer_show: false,
        draw_layer_datalayer: null,
        editlayer_resetdata: null,
        editlayer_custom: false,
        editting: null,
        layer: {
            loading: false,
            success: false,
            error: false,
            errordata: null,
        },
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        }
    });
};

const stoorNuweVersionCustomLayerSuccess = (state, action) => {
    return updateObject(state, {
        temp_layer_show: false,
        draw_layer_datalayer: null,
        editlayer_custom: false,
        editting: null,
        layer: {
            loading: false,
            success: false,
            error: false,
            errordata: null,
        }
    });
};

const stoorCustomLayerFailed = (state, action) => {
    return updateObject(state, {
        layer: {
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const stoorCustomLayerClearnotification = (state, action) => {
    return updateObject(state, {
        layer: {
            loading: false,
            success: false,
            error: false,
            errordata: null,
        }
    });
};

const initKryLayerlys_custom = (state, action) => {
    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            loading: true
        }
    });
};

const setLayerlys_custom = (state, action) => {
    let editeddata = _.cloneDeep(action.data);
    editeddata = editeddata.map(item => {
        let index = state.layersmetadata_custom.data.map(itm => itm.id).indexOf(item.id);
        item.gekiesdeweergawes = state.layersmetadata_custom.data[index] !== -1 ? state.layersmetadata_custom.data[index]?.gekiesdeweergawes || [] : [];
        return item;
    });

    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: editeddata,
            loading: false
        }
    });
};

const getLayerlysFailed_custom = (state, action) => {
    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message },
            loading: false
        }
    });
};

const toggleLayerDropdown_custom = (state, action) => {
    let tempActiveItems = [...state.layerDropdown_custom];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
    } else {
        tempActiveItems.push(action.key);
    }
    return updateObject(state, { layerDropdown_custom: tempActiveItems });
};

const kiesLayer_custom = (state, action) => {
    let tempActiveItems = [...state.layersAkief_custom];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
    } else {
        tempActiveItems.push(action.key);
    }

    const newlayersmetadata = [...state.layersmetadata_custom.data];
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            layer.gekiesdeweergawes = [_.sortBy(layer.weergawes, "id", "desc")[0].id];
        }
    }

    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        },
        layersAkief_custom: tempActiveItems
    });
};

const kiesLayerVersion_custom = (state, action) => {
    const newlayersmetadata = [...state.layersmetadata_custom.data];
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            let tempActiveItems = [...layer.gekiesdeweergawes];
            if (tempActiveItems.indexOf(action.version) > -1) {
                tempActiveItems.splice(tempActiveItems.indexOf(action.version), 1);
            } else {
                tempActiveItems.push(action.version);
            }
            layer.gekiesdeweergawes = tempActiveItems;
        }
    }

    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        }
    });
};

const setLayerVersion_custom = (state, action) => {
    let newlayersmetadata = _.cloneDeep(state.layersmetadata_custom.data);
    newlayersmetadata = newlayersmetadata.map(item => {
        let index = item.weergawes.map(itm => itm.id).indexOf(action.version);
        if (index !== -1) {
            item.weergawes[index].datalayer = action.datalayer;
            item.weergawes[index].data = action.data;
            item.weergawes[index].features = action.len;
        }
        return item;
    });
    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        },
    });
};

const removeLayer_custom = (state, action) => {
    let tempActiveItems = [...state.layersAkief_custom];
    tempActiveItems.splice(tempActiveItems.indexOf(action.key));

    const newlayersmetadata = [...state.layersmetadata_custom.data];
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            for (const weergawe of layer.weergawes) {
                if (weergawe.datalayer) {
                    weergawe.datalayer.forEach((feature) => {
                        weergawe.datalayer.remove(feature);
                    });
                    delete weergawe.infowindows;
                    delete weergawe.infowindowstype;
                }
            }
            layer.gekiesdeweergawes = [];
        }
    }

    return updateObject(state, {
        layersAkief_custom: tempActiveItems,
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        }
    });
};

const removeLayerVersion_custom = (state, action) => {
    const newlayersmetadata = [...state.layersmetadata_custom.data];
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            let tempActiveItems = _.cloneDeep(layer.gekiesdeweergawes);
            if (tempActiveItems.indexOf(action.version) > -1) {
                tempActiveItems.splice(tempActiveItems.indexOf(action.version), 1);
            }
            layer.gekiesdeweergawes = tempActiveItems;
            for (const weergawe of layer.weergawes) {
                delete weergawe.infowindows;
                delete weergawe.infowindowstype;
            }
        }
    }

    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        }
    });
};

const makeVersionEditable_custom = (state, action) => {
    const newlayersmetadata = _.cloneDeep(state.layersmetadata_custom.data);
    let data;
    for (var layer of newlayersmetadata) {
        if (layer.id === action.layer) {
            for (const weergawe of layer.weergawes) {
                if (weergawe.id === action.version && weergawe.datalayer) {
                    data = _.clone(weergawe.data);
                }
            }
        }
    }

    return updateObject(state, {
        temp_layer_show: true,
        editlayer_custom: true,
        editlayer_resetdata: data,
        draw_layer_datalayer: action.datalayer,
        editting: {
            layer: action.layer,
            weergawe: action.version
        },
    });
};

const setMakeVersionEditable_custom = (state, action) => {
    const newlayersmetadata = _.cloneDeep(state.layersmetadata_custom.data);
    for (var layer of newlayersmetadata) {
        if (layer.id === action.layer) {
            for (const weergawe of layer.weergawes) {
                delete weergawe.infowindows;
                delete weergawe.infowindowstype;
                if (weergawe.id === action.version && weergawe.datalayer) {
                    weergawe.datalayer = action.datalayer;
                }
            }
        }
    }

    return updateObject(state, {
        draw_layer_datalayer: action.datalayer,
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        },
        drawingManager: action.drawingManager
    });
};

const kanselleerEdit_custom = (state, action) => {
    const newlayersmetadata = [...state.layersmetadata_custom.data];
    for (var layer of newlayersmetadata) {
        if (layer.id === state.editting.layer) {
            for (const weergawe of layer.weergawes) {
                if (weergawe.id === state.editting.weergawe && weergawe.datalayer) {
                    weergawe.datalayer.loadGeoJson(state.editlayer_resetdata, { idPropertyName: 'id' });
                    weergawe.datalayer.setStyle(feature => {
                        let icon = {};
                        if (feature?.getGeometry()?.getType() === "Point") {
                            icon = {
                                icon: {
                                    path: feature.getProperty("iconPath") || "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
                                    fillColor: feature.getProperty("fillColor"),
                                    fillOpacity: feature.getProperty("fillOpacity"),
                                    strokeColor: feature.getProperty("strokeColor"),
                                    strokeWeight: feature.getProperty("strokeWeight"),
                                    strokeOpacity: feature.getProperty("strokeOpacity"),
                                    anchor: new window.google.maps.Point(12, 24),
                                    scale: 1.5
                                }
                            };
                        }
                        return {
                            strokeColor: feature.getProperty("strokeColor"),
                            strokeWeight: feature.getProperty("strokeWeight"),
                            strokeOpacity: feature.getProperty("strokeOpacity"),
                            fillColor: feature.getProperty("fillColor"),
                            fillOpacity: feature.getProperty("fillOpacity"),
                            ...icon,
                            zIndex: 9998,
                            clickable: true,
                            editable: false,
                            draggable: false
                        };
                    });
                }
            }
        }
    }

    return updateObject(state, {
        temp_layer_show: false,
        draw_layer_datalayer: null,
        editlayer_custom: false,
        editting: null,
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        },
        logs: []
    });
};

const showFeatureInfoBox = (state, action) => {
    const newlayersmetadata = _.cloneDeep(state.layersmetadata_custom.data);
    for (var layer of newlayersmetadata) {
        if (layer.id === action.layer) {
            for (const weergawe of layer.weergawes) {
                if (weergawe.id === action.version) {
                    let infowindows = [];
                    weergawe.datalayer.forEach(feature => {
                        if ((action.afdeling === "beskrywing" && feature.getProperty("beskrywing")) || action.afdeling === "inligting") {
                            let latLng = null;
                            if (feature?.getGeometry()?.getType() === "Point") {
                                latLng = feature.getGeometry()?.get();
                            } else {
                                var bounds = new action.google.maps.LatLngBounds();
                                feature.getGeometry().forEachLatLng((coord) => {
                                    bounds.extend(coord);
                                });
                                latLng = bounds.getCenter();
                            }
                            let obj = {};
                            if (action.afdeling === "inligting") {
                                let inligting = [];
                                let geometry = feature?.getGeometry();
                                if (geometry) {
                                    if (geometry.getType() === 'LineString') {
                                        let latlngs = [];
                                        geometry.forEachLatLng(latLng => latlngs.push(latLng));
                                        let distance = action.google.maps.geometry.spherical.computeLength(latlngs);
                                        inligting = [
                                            {
                                                id: "m",
                                                name: "Afstand (m)",
                                                value: distance.toFixed(2)
                                            },
                                            {
                                                id: "km",
                                                name: "Afstand (km)",
                                                value: (distance / 1000).toFixed(2)
                                            },
                                        ];
                                    } else if (geometry.getType() === 'Point') {
                                        inligting = [
                                            {
                                                id: "lat",
                                                name: "Latitude",
                                                value: geometry.get().lat().toFixed(4)
                                            },
                                            {
                                                id: "lng",
                                                name: "Longitude",
                                                value: geometry.get().lng().toFixed(4)
                                            }
                                        ];
                                    } else if (geometry.getType() === 'Polygon') {
                                        let latlngs = [];
                                        geometry.forEachLatLng(latLng => latlngs.push(latLng));
                                        let area = action.google.maps.geometry.spherical.computeArea(latlngs);
                                        let omtrek = action.google.maps.geometry.spherical.computeLength(latlngs);
                                        inligting = [
                                            {
                                                id: "ha",
                                                name: "Hektar",
                                                value: (area / 10000).toFixed(2)
                                            },
                                            {
                                                id: "m2",
                                                name: "Vierkant meter",
                                                value: area.toFixed(2)
                                            },
                                            {
                                                id: "km2",
                                                name: "Vierkant kilometer",
                                                value: (area / 1000000).toFixed(2)
                                            },
                                            {
                                                id: "m1",
                                                name: "Omtrek (m)",
                                                value: omtrek.toFixed(2)
                                            },
                                            {
                                                id: "km1",
                                                name: "Omtrek (km)",
                                                value: (omtrek / 1000).toFixed(2)
                                            },
                                        ];
                                    }
                                }
                                obj = {
                                    inligting: inligting
                                };
                            } else if (action.afdeling === "beskrywing") {
                                obj = {
                                    notas: feature.getProperty("beskrywing") || "<div></div>"
                                };
                            }

                            infowindows.push({
                                id: feature.getId(),
                                coordinates: latLng,
                                ...obj
                            });
                        }
                    });
                    weergawe.infowindows = infowindows;
                    weergawe.infowindowstype = action.afdeling;
                }
            }
        }
    }

    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata,
        }
    });
};

const deleteCustomLayerVersionLoading = (state, action) => {
    return updateObject(state, {
        layer: {
            ...state.layer,
            loading: true,
        }
    });
};

const deleteCustomLayerVersionSuccess = (state, action) => {
    return updateObject(state, {
        layer: {
            ...state.layer,
            loading: false,
            success: false,
        },
        telling: 3,
        editlayer_custom: false,
        editting: null,
    });
};

const deleteCustomLayerVersionSuccessMessage = (state, action) => {
    return updateObject(state, {
        layer: {
            loading: false,
            success: true,
            error: false,
            errordata: null,
        },
    });
};

const deleteCustomLayerVersionFailed = (state, action) => {
    return updateObject(state, {
        layer: {
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const stoorLayerNaam = (state, action) => {
    let log = {
        aksie: "EDIT",
        objek: "LAYERNAME",
        layer: action.layer
    };
    return updateObject(state, {
        logs: [...state.logs, log]
    });
};

const stoorLayerNaamLoading = (state, action) => {
    return updateObject(state, {
        layernaam: {
            ...state.layernaam,
            loading: true,
        }
    });
};

const stoorLayerNaamSuccess = (state, action) => {
    return updateObject(state, {
        layernaam: {
            ...state.layernaam,
            loading: false,
            success: false,
        },
        telling: 3
    });
};

const stoorLayerNaamSuccessMessage = (state, action) => {
    return updateObject(state, {
        layernaam: {
            loading: false,
            success: true,
            error: false,
            errordata: null,
        },
    });
};

const stoorLayerNaamFailed = (state, action) => {
    return updateObject(state, {
        layernaam: {
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const setLayerNaamEdit = (state, action) => {
    return updateObject(state, {
        naamedit: action.layer
    });
};

const addCustomLayerLog = (state, action) => {
    return updateObject(state, {
        logs: [...state.logs, action.log]
    });
};

const clearCustomLayerLogs = (state, action) => {
    return updateObject(state, {
        logs: []
    });
};

const setIcons_CustomLayers = (state, action) => {
    return updateObject(state, {
        icons: {
            loading: false,
            error: false,
            errordata: null,
            data: action.data,
            filteredData: action.data
        },
    });
};

const getIconsFailed_CustomLayers = (state, action) => {
    return updateObject(state, {
        icons: {
            loading: false,
            data: [],
            filteredData: [],
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const searchIcons_CustomLayers = (state, action) => {
    let data = _.cloneDeep(state.icons.data);

    const filteredData = data.filter((item) => {
        return (
            item.tags.filter(itm => itm.toString()?.toLowerCase().indexOf(action.phrase.toLowerCase()) !== -1).length > 0 ||
            item.name.toString()?.toLowerCase().indexOf(action.phrase.toLowerCase()) !== -1
        );
    });

    return updateObject(state, {
        icons: {
            ...state.icons,
            loading: false,
            filteredData: filteredData
        },
    });
};

const setDrawingMode_CustomLayers = (state, action) => {
    return updateObject(state, {
        drawingmode: action.mode
    });
};

const saveTemplaatIcon_CustomLayers = (state, action) => {
    let newStyle = _.cloneDeep(action.style);
    newStyle.id = v4();
    let icons = _.union([...state.templaaticons, newStyle]);
    return updateObject(state, {
        templaaticons: icons
    });
};

const gebruikTemplaatIcon_CustomLayers = (state, action) => {
    const newlayersmetadata = [...state.layersmetadata_custom.data];
    for (var layer of newlayersmetadata) {
        for (var weergawe of layer.weergawes) {
            if (weergawe.id === state.editting.weergawe && weergawe.datalayer) {
                for (const [name, value] of Object.entries(action.style)) {
                    action.feature.setProperty(name, value);
                }
                weergawe.datalayer.overrideStyle(action.feature, action.style);
            }
        }
    }

    let activeFeature = {
        ...state.activeFeature,
        style: action.style
    };

    return updateObject(state, {
        layersmetadata_custom: {
            ...state.layersmetadata_custom,
            data: newlayersmetadata
        },
        activeFeature: activeFeature
    });
};

const kiesTemplaatIcon_CustomLayers = (state, action) => {
    return updateObject(state, {
        templaaticon: action.style
    });
};

const stelKoordinate_CustomLayers = (state, action) => {
    let log = {
        aksie: "EDIT",
        objek: "FEATURE",
        layer: state.editting?.layer,
        version: state.editting?.weergawe,
        feature: action.id
    };

    return updateObject(state, {
        logs: [...state.logs, log]
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.LAYERLEFTSIDEBAR_TOGGLE:
            return toggleLayerLeftSidebar(state, action);
        case actionTypes.SKEP_TEMP_CUSTOM_LAYER:
            return skepTempCustomLayer(state, action);
        case actionTypes.EDIT_TEMP_CUSTOM_LAYER_ERROR:
            return editTempCustomLayerError(state, action);
        case actionTypes.TOGGLE_FEATURE_INFOBOX:
            return toggleFeatureInfoBox(state, action);
        case actionTypes.VERWYDER_FEATURE:
            return verwyderFeature(state, action);
        case actionTypes.STOOR_CUSTOM_LAYER_LOADING:
            return stoorCustomLayerLoading(state, action);
        case actionTypes.STOOR_CUSTOM_LAYER_SUCCESS_MESSAGE:
            return stoorCustomLayerSuccessMessage(state, action);
        case actionTypes.STOOR_CUSTOM_LAYER_SUCCESS:
            return stoorCustomLayerSuccess(state, action);
        case actionTypes.STOOR_NUWE_CUSTOM_LAYER_SUCCESS:
            return stoorNuweVersionCustomLayerSuccess(state, action);
        case actionTypes.STOOR_CUSTOM_LAYER_FAILED:
            return stoorCustomLayerFailed(state, action);
        case actionTypes.INIT_LAYERSLYS_CUSTOM:
            return initKryLayerlys_custom(state, action);
        case actionTypes.SET_LAYERSLYS_CUSTOM:
            return setLayerlys_custom(state, action);
        case actionTypes.GET_LAYERSLYS_FAILED_CUSTOM:
            return getLayerlysFailed_custom(state, action);
        case actionTypes.LAYER_TOGGLE_CUSTOM:
            return toggleLayerDropdown_custom(state, action);
        case actionTypes.KIES_LAYER_CUSTOM:
            return kiesLayer_custom(state, action);
        case actionTypes.KIES_LAYER_VERSION_CUSTOM:
            return kiesLayerVersion_custom(state, action);
        case actionTypes.SET_LAYERSAKTIEF_VERSION_CUSTOM:
            return setLayerVersion_custom(state, action);
        case actionTypes.REMOVE_LAYER_CUSTOM:
            return removeLayer_custom(state, action);
        case actionTypes.REMOVE_LAYER_VERSOIN_CUSTOM:
            return removeLayerVersion_custom(state, action);
        case actionTypes.SET_MAKE_LAYER_EDITABLE_CUSTOM:
            return setMakeVersionEditable_custom(state, action);
        case actionTypes.MAKE_LAYER_EDITABLE_CUSTOM:
            return makeVersionEditable_custom(state, action);
        case actionTypes.EDIT_TEMP_CUSTOM_LAYER_KANSELLEER:
            return kanselleerEdit_custom(state, action);
        case actionTypes.STOOR_CUSTOM_LAYER_CLEARNOTIFICATION:
            return stoorCustomLayerClearnotification(state, action);
        case actionTypes.SKEP_CUSTOM_LAYER_LOADING:
            return skepCustomLayerLoading(state, action);
        case actionTypes.SKEP_CUSTOM_LAYER_SUCCESS:
            return skepCustomLayerSuccess(state, action);
        case actionTypes.SKEP_CUSTOM_LAYER_FAILED:
            return skepCustomLayerFailed(state, action);
        case actionTypes.SKEP_CUSTOM_LAYER_CLEARNOTIFICATION:
            return skepCustomLayerClearnotification(state, action);
        case actionTypes.SKEP_CUSTOM_LAYER_TELLING:
            return skepCustomLayerTelling(state, action);
        case actionTypes.SKEP_CUSTOM_LAYER_CLOSE:
            return skepCustomLayerClose(state, action);
        case actionTypes.SHOW_FEATURE_INFOBOX:
            return showFeatureInfoBox(state, action);
        case actionTypes.CLOSE_FEATURE_INFOBOX:
            return closeInfoWindow_custom(state, action);
        case actionTypes.DELETE_CUSTOM_LAYER_VERSION_LOADING:
            return deleteCustomLayerVersionLoading(state, action);
        case actionTypes.DELETE_CUSTOM_LAYER_VERSION_SUCCESS_MESSAGE:
            return deleteCustomLayerVersionSuccessMessage(state, action);
        case actionTypes.DELETE_CUSTOM_LAYER_VERSION_SUCCESS:
            return deleteCustomLayerVersionSuccess(state, action);
        case actionTypes.DELETE_CUSTOM_LAYER_VERSION_FAILED:
            return deleteCustomLayerVersionFailed(state, action);
        case actionTypes.CHANGE_LAYER_NAME:
            return stoorLayerNaam(state, action);
        case actionTypes.CHANGE_LAYER_NAME_LOADING:
            return stoorLayerNaamLoading(state, action);
        case actionTypes.CHANGE_LAYER_NAME_SUCCESS_MESSAGE:
            return stoorLayerNaamSuccessMessage(state, action);
        case actionTypes.CHANGE_LAYER_NAME_SUCCESS:
            return stoorLayerNaamSuccess(state, action);
        case actionTypes.CHANGE_LAYER_NAME_FAILED:
            return stoorLayerNaamFailed(state, action);
        case actionTypes.SET_CHANGE_LAYER_NAME:
            return setLayerNaamEdit(state, action);
        case actionTypes.ADD_CUSTOM_LAYER_LOG:
            return addCustomLayerLog(state, action);
        case actionTypes.CLEAR_CUSTOM_LAYER_LOGS:
            return clearCustomLayerLogs(state, action);
        case actionTypes.EDIT_FEATURE_PROPERTY:
            return editFeatureProperty(state, action);
        case actionTypes.SET_ICONS_CL:
            return setIcons_CustomLayers(state, action);
        case actionTypes.GET_ICONS_FAILED_CL:
            return getIconsFailed_CustomLayers(state, action);
        case actionTypes.SEARCH_ICONS_CL:
            return searchIcons_CustomLayers(state, action);
        case actionTypes.SET_DRAWINGMODE_CUSTOM_LAYER:
            return setDrawingMode_CustomLayers(state, action);
        case actionTypes.SAVE_TEMPLAATICON_CUSTOM_LAYER:
            return saveTemplaatIcon_CustomLayers(state, action);
        case actionTypes.GEBRUIK_TEMPLAATICON_CUSTOM_LAYER:
            return gebruikTemplaatIcon_CustomLayers(state, action);
        case actionTypes.KIES_TEMPLAATICON_CUSTOM_LAYER:
            return kiesTemplaatIcon_CustomLayers(state, action);
        case actionTypes.STEL_KOORDINATE_CUSTOM_LAYER:
            return stelKoordinate_CustomLayers(state, action);
        default:
            return state;
    }
};

export default reducer;